(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'easeControl',
            [
                'CHROME',
                EaseControlFactory
            ]
        );

    // Factory Method
    function EaseControlFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.PROJECT.CONTROL.EASE + CHROME.POSTFIX
        };

    }
})();



